import { environment } from './../../../environments/environment';
import { Component, Optional, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { DocumentSelectComponent } from '../../Selects/document-select/document-select.component';

@Component({
  selector: 'app-mailing-form',
  templateUrl: './mailing-form.component.html',
  styles: []
})
export class MailingFormComponent {

  action: string;
  local_data: any;
  document: string = '';
  selectedImage: any = '';
  documentos: any[] = [];

  constructor(

    private dialog: MatDialog,
    public datePipe: DatePipe,
    public dialogRef: MatDialogRef<MailingFormComponent>,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.local_data = { ...data };
    if (!this.local_data.cuerpo) {
      this.local_data.cuerpo = `
      <p class="ql-align-center">
      <img src="https://www.cafsevilla.com/wp-content/uploads/2019/02/cafs-newsletter-circular-${this.local_data.clasificacion || 'gris'}.png" alt="cabecera"  width="640"></p>
      <p><br></p>
      <p><br></p>
      <p><br></p>
      <p><br></p>
      <p><br></p>
      <p><br></p>
      <p><br></p>
      <p><br></p>
      <p><br></p>
      <p class="ql-align-center"><span style="color: rgb(128, 128, 128);"><img src="https://www.cafsevilla.com/wp-content/uploads/2019/02/faldon-2-13-${this.local_data.clasificacion || 'gris'}.jpg" alt="faldon-2-13" width="640"></span></p>
      <p><br></p>`
    }
    this.action = this.local_data.action;

  }


  doAction(): void {
    this.local_data.fecha = new Date();
    this.dialogRef.close({ event: this.action, data: this.local_data });
  }
  closeDialog(): void {
    this.dialogRef.close({ event: 'Cancel' });
  }

  addDoc() {
    const dialogRef = this.dialog.open(DocumentSelectComponent, {});
    dialogRef.afterClosed().subscribe(async result => {
      if (!result) return;
      this.document = this.document + `<p><a href="${environment.backendUrl}/documentos/download/DOCUMENTO/${result.doc}" rel="noopener noreferrer" target="_blank">${result.titulo}</a></p>`
      this.local_data.cuerpo = `

      <p class="ql-align-center">
      <img src="https://cafsevilla.com/wp-content/uploads/2019/02/cafs-newsletter-circular-${this.local_data.clasificacion || 'gris'}.png" alt="cabecera" width="600"></p>
      <p><br></p>
      ${this.document}
      <p><br></p>
      <p><br></p>
      <p><br></p>
      <p><br></p>
      <p><br></p>
      <p><br></p>
      <p><br></p>
      <p><br></p>
      <p class="ql-align-center"><span style="color: rgb(128, 128, 128);"><img src="https://cafsevilla.com/wp-content/uploads/2019/02/faldon-2-13-${this.local_data.clasificacion || 'gris'}.jpg" alt="faldon-2-13" width="660"></span></p>
      <p><br></p>
`;
    });

  }

  changeClass() {
    const clasificacion = this.local_data.clasificacion || 'gris';

    // Sustituye la imagen de cabecera
    this.local_data.cuerpo = this.local_data.cuerpo.replace(
      /cafs-newsletter-circular-[^"]+/g,
      `cafs-newsletter-circular-${clasificacion}.png`
    );

    // Sustituye la imagen del faldón
    this.local_data.cuerpo = this.local_data.cuerpo.replace(
      /faldon-2-13-[^"]+/g,
      `faldon-2-13-${clasificacion}.jpg`
    );
  }
}
